import { createSession } from '../utils/jbSession';

let saveToken = { expires: 0, token: '' }

export async function requestToken() {
	return new Promise((resolve, reject) => {
		if (saveToken.token != '' && saveToken.expires > Date.now()) {
			resolve(saveToken.token);
		} else {
			const connection = createSession();

			connection.on('requestedTokens', async (tokens) => {
				// console.log(`requestedTokens is ${JSON.stringify(tokens)}`);
				if (tokens && tokens.fuel2token && tokens.expires) {
					saveToken.expires = tokens.expires;
					saveToken.token = tokens.fuel2token;
					resolve(tokens.fuel2token);
				} else {
					reject('JB did not return a valid token.')
				}
			});

			connection.trigger('requestTokens');
		}
	});
}

export function setToken(expires, token) {
	saveToken.expires = expires;
	saveToken.token = token;
}